export const getEnvironment = () => {
    const hostname = window.location.hostname;
  
    // Check for production hostname
    if (hostname === 'partner.hellolunajoy.com') {
      return 'production';
    }
    
    // Check for development hostname
    if (hostname === 'partner-dev.hellolunajoy.com') {
      return 'development';
    }
  
    return 'development';
  };
  
export const isProduction = () => {
    return getEnvironment() === 'production';
};

export const getServiceUrl = (service, clinicCode) => {
    const isProd = isProduction();
    const baseUrl = isProd 
      ? `https://${service}.hellolunajoy.com`
      : `https://${service}-dev.hellolunajoy.com`;
    
    if (service === 'booking' && clinicCode) {
      return `${baseUrl}/?referal=${clinicCode}`;
    } else if (service === 'referral' && clinicCode) {
      return `${baseUrl}/${clinicCode}`;
    }
    
    return baseUrl;
  }; 